import { render, staticRenderFns } from "./matching-badge-modal.vue?vue&type=template&id=0bc7c3ae&scoped=true&"
import script from "./matching-badge-modal.vue?vue&type=script&lang=ts&"
export * from "./matching-badge-modal.vue?vue&type=script&lang=ts&"
import style0 from "./matching-badge-modal.vue?vue&type=style&index=0&id=0bc7c3ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc7c3ae",
  null
  
)

export default component.exports